import { render, staticRenderFns } from "./trainRoomManagers.vue?vue&type=template&id=970a3864&scoped=true"
import script from "./trainRoomManagers.vue?vue&type=script&lang=js"
export * from "./trainRoomManagers.vue?vue&type=script&lang=js"
import style0 from "./trainRoomManagers.vue?vue&type=style&index=0&id=970a3864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a3864",
  null
  
)

export default component.exports